import { Dispatch, FC, SetStateAction } from 'react'

import { ChevronRight } from '@/components/atoms/assets/ChevronRight'
import { SubscribeCategoryButton } from '@/components/molecules/SubscribeCategoryButton'

import { Category, ExploreCategory } from '@/services/categories'

import { CategorySlide } from './CategorySlide'
import { ExploreMoreSlide } from './ExploreMoreSlide'

type CategorySliderProps = {
  category: ExploreCategory
  setSelectedCategory: Dispatch<SetStateAction<Category>>
}

export const CategorySlider: FC<CategorySliderProps> = ({
  category,
  setSelectedCategory,
}) => {
  const handleSelectCategory = () => {
    setSelectedCategory({ id: category.id, name: category.name })
  }

  return (
    <div className="px-3 pb-[1.875rem]">
      <div className="flex justify-between mb-4">
        <div
          className="flex items-center cursor-pointer"
          onClick={handleSelectCategory}
        >
          <span className="font-semibold text-white mr-1">{category.name}</span>
          <ChevronRight className="w-4 h-4" />
        </div>
        <SubscribeCategoryButton categoryId={category.id} />
      </div>

      <div className="clear-both overflow-x-scroll flex">
        {category.activities.map((activity) => (
          <CategorySlide key={activity.id} activity={activity} />
        ))}
        <ExploreMoreSlide onClick={handleSelectCategory} />
      </div>
    </div>
  )
}
